import { useContext, useEffect, useRef } from "react";
import { UseFormGetValues } from "react-hook-form";
import { DEFAULT_PRESCRIPTION_VALUES } from "src/constants/cases";

// import { DEFAULT_PRESCRIPTION_VALUES } from "src/constants/addCase";
import { AuthContext } from "src/context/authContext";
import { CaseContext } from "src/context/caseContext";

import { AddCaseProps } from "src/pages/addCase/types";
import { PrescriptionObjKeyProps } from "src/types/case";




export function usePageTrackingAndStorage(fetchLatestData: UseFormGetValues<AddCaseProps>, isDirty: boolean, isSubmitted: boolean, step: number) {
  const { isUserAuthorized } = useContext(AuthContext)
  const isDirtyRef = useRef<boolean>()
  const stepRef = useRef<number>()
  const isUserRef = useRef<boolean>()
  const isSubmitRef = useRef<boolean>()
  const { isCaseDraftSaved, draftCaseId } = useContext(CaseContext)
  const refBaseCaseDraftCheck = useRef(isCaseDraftSaved)
  const refDraftCaseId = useRef(draftCaseId)

  const isPrescriptionAttributesUpdated = () => {
    const updatedPrescriptionValues = fetchLatestData("prescription_attributes")
    return Object.keys(updatedPrescriptionValues).some((key: unknown) => {
      if (key === "diagnosis_code")
        return false
      else
        return updatedPrescriptionValues[key as PrescriptionObjKeyProps] !== DEFAULT_PRESCRIPTION_VALUES[key as PrescriptionObjKeyProps]
    });
  }

  // Handle page refresh / close
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (typeof isUserRef.current === "boolean" && isUserRef.current === true) {
        if (typeof isSubmitRef.current === "boolean" && isSubmitRef.current === false) {
          if ((isPrescriptionAttributesUpdated() || (typeof isDirtyRef.current === "boolean" && isDirtyRef.current === true)) && !refBaseCaseDraftCheck.current) {
            localStorage.setItem('newCase', JSON.stringify({ newData: fetchLatestData(), step: stepRef.current, draftCaseId: refDraftCaseId.current }))
          }
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      // Save to localStorage on route change
      handleBeforeUnload()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    isDirtyRef.current = isDirty
  }, [isDirty])

  useEffect(() => {
    stepRef.current = step
  }, [step])

  useEffect(() => {
    isUserRef.current = isUserAuthorized
  }, [isUserAuthorized])

  useEffect(() => {
    isSubmitRef.current = isSubmitted
  }, [isSubmitted])

  useEffect(() => {
    refDraftCaseId.current = draftCaseId;
  }, [draftCaseId]);

  useEffect(() => {
    refBaseCaseDraftCheck.current = isCaseDraftSaved;
  }, [isCaseDraftSaved]);
};
